import styled from '@emotion/styled'

export const StyledReturnButton = styled.div`

    /* direction: rtl; */

    display: inline-block;

`